(function ($) {
// 3-Step Shop by Step Mobile v1
  threeStepShopByStepMobileV1 = {
    formatter: $('.three-step-shopbystep-mobile-v1')
  };

  Drupal.behaviors.threeStepShopByStepMobileV1 = {
    get: function (key) {
      return threeStepShopByStepMobileV1[key];
    },

    set: function (key, val) {
      threeStepShopByStepMobileV1[key] = val;
    },

    attach: function (context, settings) {
      if ($('body').hasClass('device-mobile')) { // only if on mobile site...
	     var self = this;
        var formatter = self.get('formatter');

        formatter.each(function (i) {
          var thisFormatter = $(this);

          // Accordion Functionality
          thisFormatter.find('h3').on('click', function() {
            var $h3 = $(this);

            $h3.toggleClass('selected');
            $h3.parent().siblings().children('h3').removeClass('selected');
            $h3.parent().siblings().find('h3').next().hide();
            var $h3 = $(this);

            $(this).next().slideToggle(500, function () {
              $('body, html').scrollTo($h3, {
                duration: 500,
                axis: 'y'
              });
            });
          });
        });
        // Init site.mpp
        site.mpp.data = {
          category: page_data['category-input-type'].categories[0],
          categories: page_data['category-input-type'].categories
        };
        site.mpp.init();
      }
    }
  };
})(jQuery);
